import TermsOfService from "../../components/legal/terms/TermsOfService"

function TermsOfServicePage() {
    return (
        <TermsOfService />
    )
}

export default TermsOfServicePage;